import { Flex } from "@chakra-ui/layout";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import { MensagemForm } from "core/features/mensagens/typings";
import {
  StatusReservaEnum,
  ListagemReservaResponse,
} from "core/features/reservas/typings";
import moment from "moment";
import { FaBirthdayCake, FaCalendarWeek } from "react-icons/fa";
import { IoBarbellSharp } from "react-icons/io5";
import { MdOutdoorGrill } from "react-icons/md";
import colors from "resources/theme/colors";
export function getTypeTag(status: StatusReservaEnum) {
  switch (status) {
    case StatusReservaEnum.AguardandoPagamento:
      return "Aguardando pagamento";
    case StatusReservaEnum.Cancelada:
      return "Cancelada";
    case StatusReservaEnum.Confirmada:
      return "Confirmada";
    case StatusReservaEnum.Pendente:
      return "Pendente";
    default:
      return "--";
  }
}

export function getTagColor(status: StatusReservaEnum) {
  switch (status) {
    case StatusReservaEnum.AguardandoPagamento:
      return "yellow";
    case StatusReservaEnum.Cancelada:
      return "red";
    case StatusReservaEnum.Confirmada:
      return "green";
    case StatusReservaEnum.Pendente:
      return "cyan";
    default:
      return "gray";
  }
}

export function getCalendarTagColor(status: StatusReservaEnum) {
  switch (status) {
    case StatusReservaEnum.AguardandoPagamento:
      return colors.yellow500;
    case StatusReservaEnum.Cancelada:
      return colors.red;
    case StatusReservaEnum.Confirmada:
      return colors.green500;
    case StatusReservaEnum.Pendente:
      return colors.cyan;
    default:
      return colors.lightGray;
  }
}

const IconWrapper = ({
  bg,
  children,
  size = 24,
}: {
  bg: string;
  children: React.ReactNode;
  size?: number;
}) => (
  <Flex
    bg={bg}
    w="40px"
    h="40px"
    rounded="full"
    alignItems="center"
    justifyContent="center"
  >
    {children}
  </Flex>
);
export function getIconForAreaComum(
  tipo: string,
  showBg = true,
  size = 24,
  color?: string
) {
  switch (tipo) {
    case "bolo":
      return (
        <IconWrapper bg={showBg ? "#FFB93E15" : "transparent"} size={size}>
          <FaBirthdayCake size={size} color={color || "#FFA412"} />
        </IconWrapper>
      );
    case "churrasqueira":
      return (
        <IconWrapper
          bg={showBg ? "#EE532215" : "transparent"}
          size={size * (1 + 1 / 6)}
        >
          <MdOutdoorGrill
            size={size * (1 + 1 / 6)}
            color={color || "#EE5322"}
          />
        </IconWrapper>
      );
    case "academia":
      return (
        <IconWrapper bg={showBg ? "#22A6F015" : "transparent"} size={size}>
          <IoBarbellSharp size={size} color={color || "#22A6F0"} />
        </IconWrapper>
      );
    default:
      return (
        <IconWrapper bg={showBg ? "#4F52FF15" : "transparent"} size={size}>
          <FaCalendarWeek size={size} color={color || "#4F52FF"} />
        </IconWrapper>
      );
  }
}

export function formatHorario(horaInicio?: string, horaFim?: string) {
  if (horaInicio && horaFim) {
    return `${horaInicio?.slice(0, 5)}h às ${horaFim?.slice(0, 5)}h`;
  } else if (horaInicio) {
    return `${horaInicio?.slice(0, 5)}h`;
  }

  return "--:--";
}

export function formatUnidadeBloco(numero: string, blocoQuadra?: string) {
  return `${numero}${blocoQuadra ? " Bloco/Quadra " + blocoQuadra : ""}`;
}

export function getDefaultValuesForMessageModal(
  reserva: Partial<ListagemReservaResponse>
) {
  return {
    assuntoCustomizado: reserva.areaComum?.nome
      ? `Sobre a reserva do espaço ${reserva.areaComum.nome} do dia ${moment(
          reserva.data
        ).format("DD/MM/YYYY")}`
      : "Sobre a reserva",
    tipoDestinoId: TipoDestinoEnum.UmaUnidade,
    destinoId: reserva.unidade?.id,
    destinos: reserva.unidade
      ? [
          {
            destinoId: reserva.unidade?.id,
            label: formatUnidadeBloco(
              reserva.unidade.numero,
              reserva.unidade.blocoQuadra
            ),
            tipoDestinoId: TipoDestinoEnum.UmaUnidade,
          },
        ]
      : [],
    tenantId: reserva.tenant?.id,
  } as Partial<MensagemForm>;
}
